import URL from "core/resources/urls";
import http from "infra/http";

interface SalvarTalhaoEditadoProps {
  talhaoId: string;
  geometryWkt?: string;
}

export const salvarTalhaoEditado = async ({
  talhaoId,
  geometryWkt,
}: SalvarTalhaoEditadoProps) => {
  const response = await http.put(
    URL.EDITAR_TALHOES.SALVAR_TALHOES_EDITADOS(talhaoId),
    {
      geometryWkt,
    }
  );

  return response?.data;
};
